import ViewMap from "./ViewMap";
import ViewCadastreMap from "./ViewCadastreMap";
import DefaultMap from "./DefaultMap";
import EditMap from "./EditMap";
import ViewMapByCategoryPage from "./ViewMapByCategoryPage";
import ViewPlanningMap from "./ViewPlanningMap";
import ViewInfrastructureMap from "./ViewInfrastructureMap";
import ViewUnapprovedMap from "./ViewUnapprovedMap";
export {
  DefaultMap,
  ViewMap,
  ViewCadastreMap,
  EditMap,
  ViewMapByCategoryPage,
  ViewPlanningMap,
  ViewInfrastructureMap,
  ViewUnapprovedMap
};
